import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import MuiSelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { getYear } from 'date-fns';
import { renderFromHelper } from '../renderFieldError';
import InputLabel from '@material-ui/core/InputLabel';
const styles = (theme) => createStyles({
    container: {
        width: '100%',
    },
    root: {
        width: '100%',
        height: 'calc(1em + 8px)',
        paddingBottom: 3,
        '& svg': {
            color: theme.color.font.dark,
        },
    },
    select: {
        width: '100%',
        padding: 0,
    },
});
export const getYears = (startYear = 1980) => {
    let currentYear = getYear(new Date());
    const years = [];
    while (currentYear >= startYear) {
        years.push(currentYear);
        currentYear -= 1;
    }
    return years;
};
const SelectYear = (props) => {
    const { classes, name, label, input, testId = 'SelectYear', meta: { touched, error }, defaultItemLabel = 'all', startYear, ...others } = props;
    const yearListItems = getYears(startYear).map((year) => (React.createElement(MenuItem, { "data-testid": `${testId}-item-${year}`, key: year, value: year }, year)));
    const selectClasses = {
        root: classes.root,
        select: classes.select,
    };
    return (React.createElement("div", { className: classes.container, "data-testid": `${testId}` },
        React.createElement(FormControl, { error: touched && Boolean(error), fullWidth: true },
            React.createElement(InputLabel, { shrink: true }, label),
            React.createElement(MuiSelect, Object.assign({ "data-testid": `${testId}-input` }, input, { name: name, classes: selectClasses, displayEmpty: true }, others),
                React.createElement(MenuItem, { value: '' }, defaultItemLabel),
                yearListItems),
            renderFromHelper({ touched, error }))));
};
const ComposedSelectYear = compose(withStyles(styles, { withTheme: true }), pure)(SelectYear);
ComposedSelectYear.displayName = 'SelectYear';
export default ComposedSelectYear;
//# sourceMappingURL=SelectYear.js.map